module.exports = __webpack_public_path__ + "img/2025-08-16e_1.d9890b00.jpg";